module.exports = __webpack_public_path__ + "static/media/05_galeria_plantillas_combo_simple_cuad_5.4cbf464e.png";